import { render, staticRenderFns } from "./_ReturnAddress.vue?vue&type=template&id=fad9d8e4&"
import script from "./_ReturnAddress.vue?vue&type=script&lang=js&"
export * from "./_ReturnAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports